var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransportLeftImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 124,
    viewBox: "0 0 205 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.73012 64.4595C6.32012 64.4595 5.92012 64.3095 5.61012 63.9995L2.71012 61.0995C2.09012 60.4795 2.09012 59.4795 2.71012 58.8595C3.33012 58.2395 4.33012 58.2395 4.95012 58.8595L7.85012 61.7595C8.47012 62.3795 8.47012 63.3795 7.85012 63.9995C7.54012 64.2995 7.14012 64.4595 6.73012 64.4595Z",
    fill: "#F03E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9905 122.6C29.6305 122.6 29.2805 122.46 29.0105 122.19C28.4705 121.65 28.4705 120.77 29.0105 120.23L31.5605 117.68C32.1005 117.14 32.9805 117.14 33.5205 117.68C34.0605 118.22 34.0605 119.1 33.5205 119.64L30.9705 122.19C30.7005 122.46 30.3505 122.6 29.9905 122.6Z",
    stroke: "#F03E3E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5897 123.97C79.0367 123.97 80.2097 122.797 80.2097 121.35C80.2097 119.903 79.0367 118.73 77.5897 118.73C76.1427 118.73 74.9697 119.903 74.9697 121.35C74.9697 122.797 76.1427 123.97 77.5897 123.97Z",
    fill: "#F03E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.34 102.21C89.1961 102.21 89.89 101.516 89.89 100.66C89.89 99.8043 89.1961 99.1104 88.34 99.1104C87.484 99.1104 86.79 99.8043 86.79 100.66C86.79 101.516 87.484 102.21 88.34 102.21Z",
    stroke: "#F03E3E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8496 5.25L43.3996 17.65",
    stroke: "#F03E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8096 81.5296L35.4596 75.3496",
    stroke: "#F03E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7305 108.59L70.7305 98.1904",
    stroke: "#F03E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.61035 47.21L41.9704 53.36",
    stroke: "#F03E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.959961 94.4004C1.44996 101.8 7.82996 107.4 15.24 106.92",
    stroke: "#F03E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6797 1.41016C60.6697 1.41016 57.4297 4.65016 57.4297 8.66016",
    stroke: "#F03E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.104 57.6017C157.288 55.2078 159.586 49.1414 157.236 44.052C154.886 38.9626 148.778 36.7774 143.594 39.1713C138.409 41.5652 136.111 47.6316 138.461 52.721C140.811 57.8104 146.919 59.9956 152.104 57.6017Z",
    fill: "#E03131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.164 56.1789C157.349 53.785 159.647 47.7185 157.297 42.6291C154.947 37.5397 148.839 35.3546 143.654 37.7485C138.47 40.1424 136.172 46.2088 138.521 51.2982C140.871 56.3876 146.979 58.5727 152.164 56.1789Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.32 50.49C148.85 51.4 152.5 49.3 153.46 45.79",
    stroke: "white",
    strokeWidth: 1.0328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.402 45.8959C143.728 45.7454 143.874 45.3673 143.729 45.0514C143.583 44.7355 143.2 44.6015 142.874 44.7519C142.548 44.9024 142.402 45.2805 142.548 45.5964C142.694 45.9123 143.077 46.0464 143.402 45.8959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.315 41.5687C150.641 41.4182 150.787 41.0402 150.641 40.7243C150.495 40.4084 150.112 40.2743 149.786 40.4248C149.461 40.5753 149.315 40.9533 149.46 41.2692C149.606 41.5851 149.989 41.7192 150.315 41.5687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.09 109.69H204.08V58.1797L152.09 109.69ZM197.24 100.82H171.6L197.24 74.2397V100.82Z",
    fill: "#FF8787",
    stroke: "#FF8787",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.78 78.3396L186 76.5596",
    stroke: "#F03E3E",
    strokeWidth: 1.0328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.27 84.8393L179.49 83.0693",
    stroke: "#F03E3E",
    strokeWidth: 1.0328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.35 90.7593L173.58 88.9893",
    stroke: "#F03E3E",
    strokeWidth: 1.0328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.84 97.2693L167.07 95.4893",
    stroke: "#F03E3E",
    strokeWidth: 1.0328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.88 71.24L193.1 69.46",
    stroke: "#FF8787",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4704 116.05C92.0204 114.58 92.0404 112.21 93.5204 110.76L127.95 76.9199L133.19 82.2499L98.7604 116.09C97.2904 117.55 94.9204 117.53 93.4704 116.05Z",
    fill: "#F03E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.23 66.04L125.07 73.5L139.26 87.94L145.19 82.11L131.28 67.97L123.6 63.71L121.23 66.04Z",
    fill: "#FF8787",
    stroke: "#FF8787",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.41 64.8701L142.22 85.0201",
    stroke: "#F03E3E",
    strokeWidth: 1.0328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.481 75.8796C137.991 76.3596 136.551 75.6896 135.261 74.3796C133.971 73.0696 133.331 71.6196 133.821 71.1396",
    stroke: "#F03E3E",
    strokeWidth: 1.0328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.66 73.0303L147.92 84.2203",
    stroke: "#F03E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.33 71.21L158.99 74.85",
    stroke: "#F03E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.2 106.35L115.1 108.09",
    stroke: "#F03E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.84 103.42L129.56 109.29",
    stroke: "#F03E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.63 93.8301L132.55 99.3701",
    stroke: "#F03E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.47 91.0996L146.78 96.5496",
    stroke: "#F03E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3787 94.9041L39.627 90.1523L15.8755 113.904L20.6272 118.656L44.3787 94.9041Z",
    fill: "#F03E3E",
    stroke: "#F03E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9099 85.6201L39.6299 90.1501L44.3799 94.9001L48.9099 85.6201Z",
    fill: "#FA5252",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.47 116.06L20.85 118.44C19.55 119.74 17.4 119.74 16.1 118.44C14.8 117.14 14.8 114.99 16.1 113.69C16.11 113.68 16.12 113.67 16.13 113.66L18.47 116.06Z",
    fill: "#C92A2A",
    stroke: "#C92A2A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.75 86.9101L47.62 87.7801L48.91 85.6201L46.75 86.9101Z",
    fill: "#C92A2A",
    stroke: "#C92A2A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1305 66.6603C92.4405 67.5803 92.4405 71.2703 85.0705 71.2703H66.6505C64.1105 71.2703 62.0405 69.2103 62.0405 66.6603H48.2305L51.0905 80.9603C51.5705 83.3603 53.6805 85.0903 56.1305 85.0903H94.9805C96.3405 85.0903 97.6605 84.6903 98.7905 83.9403C104.74 79.9703 109.96 74.0403 109.96 64.8203L96.1305 66.6603Z",
    fill: "#F03E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6805 85.0801H65.7305V92.4501H89.6805V85.0801Z",
    fill: "#C92A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0502 66.6609H42.7002V60.2109H57.0402C59.8002 60.2109 62.0402 62.4509 62.0402 65.2109V66.6609H62.0502Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.17 62.9707L96.1299 66.6607",
    stroke: "#F03E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4697 71.2602V66.6602",
    stroke: "#F03E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.58 65.74V59.29",
    stroke: "#F03E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 48.2308V44.5508",
    stroke: "#F03E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 33.4903V24.2803",
    stroke: "#F03E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.32 27.9604H113.38L107.93 25.9104L113.38 23.3604H102.32V27.9604Z",
    fill: "#F03E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.29 18.0905H90.34L83.07 15.2605L90.34 13.4805H79.29V18.0905Z",
    fill: "#F03E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1006 24.2809H69.1506L61.7806 22.3609L69.1506 19.6709H58.1006V24.2809Z",
    fill: "#F03E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9502 33.4902C95.9502 33.4902 100.98 36.2002 97.6402 44.0602H109.04C109.04 44.0602 109.55 37.1802 105.61 33.4902H95.9502Z",
    fill: "#FF8787",
    stroke: "#FF8787",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1807 48.0508C97.1807 48.0508 100.991 52.6008 97.1807 58.7108H110.971C110.971 58.7108 112.731 52.8408 109.041 48.2308L97.1807 48.0508Z",
    fill: "#FF8787",
    stroke: "#FF8787",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1 37.1807H87.83C87.83 37.1807 98.9 50.0807 91.53 65.7407H72C72 65.7407 82.31 53.7607 73.1 37.1807Z",
    fill: "#FF8787",
    stroke: "#FF8787",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0205 22.4307H84.3005C84.3005 22.4307 88.7605 28.4607 85.9905 32.8107H74.9405C74.9405 32.8207 79.5505 27.9607 74.0205 22.4307Z",
    fill: "#FF8787",
    stroke: "#FF8787",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8297 30.7305H63.6197C63.6197 30.7305 74.9397 37.1805 70.3297 55.6105H51.2197C51.2197 55.6005 58.3597 45.4705 52.8297 30.7305Z",
    fill: "#FF8787",
    stroke: "#FF8787",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3604 60.2105V56.5205",
    stroke: "#F03E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2803 29.8007V21.5107",
    stroke: "#F03E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4697 22.4302V16.9102",
    stroke: "#F03E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4697 37.1802V33.4902",
    stroke: "#F03E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1006 76.9307H90.5506",
    stroke: "#C92A2A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9799 81.3701H85.1299",
    stroke: "#C92A2A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9004 41.3809C86.9004 41.3809 92.1104 47.4109 90.5504 54.4109",
    stroke: "#F03E3E",
    strokeWidth: 1.0328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.65 50.54C107.65 50.54 109 50.96 109.05 54.41",
    stroke: "#F03E3E",
    strokeWidth: 1.0328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.891 35.7803C104.891 35.7803 105.931 35.8603 106.331 39.7603",
    stroke: "#F03E3E",
    strokeWidth: 1.0328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0303 24.4902C83.0303 24.4902 84.8603 25.9402 84.5603 28.8902",
    stroke: "#F03E3E",
    strokeWidth: 1.0328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9697 33.4902C63.9697 33.4902 68.2497 36.7302 67.3797 41.3802",
    stroke: "#F03E3E",
    strokeWidth: 1.0328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.93 1.3382L114.015 5.9082L118.585 13.8234L126.5 9.25344L121.93 1.3382Z",
    stroke: "#F03E3E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9204 6.49996C47.5883 6.49996 48.9404 5.14786 48.9404 3.47996C48.9404 1.81206 47.5883 0.459961 45.9204 0.459961C44.2525 0.459961 42.9004 1.81206 42.9004 3.47996C42.9004 5.14786 44.2525 6.49996 45.9204 6.49996Z",
    stroke: "#F03E3E",
    strokeWidth: 0.8805,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.27 0.780273L139.33 14.2503",
    stroke: "#F03E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportLeftImage);
export default __webpack_public_path__ + "static/media/transportLeftImage.1fe489f2f41fc37e459b82acc003533a.svg";
export { ForwardRef as ReactComponent };